import _ from 'lodash'

const INITIAL_STATE = {
    impUsers: null,
    impRequesters: null,
    unlockedUsers: null,
    onlineUsers: null,
}

function adminUserMgmReducer (state = INITIAL_STATE, action) {
    switch(action.type) {
      case 'FETCH_IMPORTEDUSERS' : {
        return ({
            ...state,
            impUsers: [...action.payload]
          })
      }
      case 'FETCH_IMPORTED_REQUESTER' : {
        return ({
            ...state,
            impRequesters: [...action.payload]
          })
      }
      case 'FETCH_UNLOCKED_USERS' : {
        return ({
            ...state,
            unlockedUsers: _.values(action.payload)
          })
      }
      case 'FETCH_USERS_ONLINE' : {
        const { payload } = action
        const onlineUsers = _.values(payload)
        return({
          ...state,
          onlineUsers: onlineUsers
        })
      }
      
      default : return state;
    }
  }
 
  export default adminUserMgmReducer;


// WEBPACK FOOTER //
// ./src/reducers/adminUserMgm.js